export const name = 'rnRequest';

/**
 * @ngdoc service
 * @name rhino.components.request.service:rnRequest
 *
 * @description Rhino Request service, provides methods to make requests to the support service
 */
export default function rnRequest($q, $log, rnHttp) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const SUPPORT_APP_SERVICE = 'supportapp_service';
  const REQUESTS_TYPES_PATH = 'requests/types';
  const REQUESTS_PATH = 'requests';

  var service = {
    getRequestTypes: getRequestTypes,
    createRequest: createRequest
  };

  return service;

  ////////////////

  /**
   * @ngdoc function
   * @name getRequestTypes
   * @methodOf rhino.components.request.service:rnRequest
   * @description Gets the valid request types for this user
   */
  function getRequestTypes() {
    let deferred = $q.defer();

    rnHttp.get(SUPPORT_APP_SERVICE, REQUESTS_TYPES_PATH)
      .then(function(response) {
        deferred.resolve(response.data); // We only care about the data
      })
      .catch(function(error) {
        deferred.reject(error.data); // We only care about the data
      });
      return deferred.promise;
  }

  /**
   * @ngdoc function
   * @name createRequest
   * @methodOf rhino.components.request.service:rnRequest
   * @description Creates a request
   * @param {object} params - a json object payload
   */
  function createRequest(params) {
    let deferred = $q.defer();

    rnHttp.post(SUPPORT_APP_SERVICE, REQUESTS_PATH, params)
      .then(function(response) {
        deferred.resolve(response.data); // We only care about the data
      })
      .catch(function(error) {
        deferred.reject(error.data); // We only care about the data
      });
      return deferred.promise;
  }

}
